import FormGroup from 'components/shared/FormGroup';
import InputText from 'components/shared/InputText';
import Modal from 'components/shared/Modal';
import {
  StyledCopyAnchor,
  StyledCopyWrapper
} from 'components/shared/ShareModal/ShareModal.styled';
import TooltipMF from 'components/shared/TooltipMF';
import { useI18n } from 'hooks/useI18n';
import { useEffect, useRef, useState } from 'react';
import ReactModal from 'react-modal';

type ShareModalProps = {
  shareModalIsOpen: boolean;
  slug: string;

  shareModalClose: () => void;
};

const BlogShareModal: React.FC<ShareModalProps> = ({
  shareModalIsOpen,
  shareModalClose,
  slug
}: ShareModalProps) => {
  const linkInputRef = useRef<HTMLInputElement>(null);
  const [copied, setCopied] = useState(false);
  const [baseUrl, setBaseUrl] = useState('');
  const { t } = useI18n('success-stories');

  useEffect(() => {
    setBaseUrl(`${window.location.origin}`);
  }, []);

  return (
    <>
      <ReactModal
        isOpen={shareModalIsOpen}
        contentLabel={t('share.title')}
        onAfterOpen={() => {
          setCopied(false);
        }}
        shouldCloseOnOverlayClick={true}
        onRequestClose={shareModalClose}
      >
        <Modal title={t('share.title')} onClose={shareModalClose}>
          <div>
            <FormGroup label={t('share.label')} forId="shareLink">
              <InputText
                id="shareLink"
                type="text"
                value={`${baseUrl}/successStories/${slug}`}
                title={slug}
                variant="copy"
                readOnly
                ref={linkInputRef}
                onClick={() => {
                  linkInputRef.current?.select();
                  document.execCommand('copy');
                  setCopied(true);
                  setTimeout(() => {
                    setCopied(false);
                  }, 2000);
                }}
              />
              <StyledCopyWrapper>
                <TooltipMF
                  content={t('share.copied')}
                  direction="up"
                  distance={65}
                  isOpen={copied}
                >
                  <StyledCopyAnchor />
                </TooltipMF>
              </StyledCopyWrapper>
            </FormGroup>
          </div>
        </Modal>
      </ReactModal>
    </>
  );
};

export default BlogShareModal;
